import router from './router'
import useProvinceStore from './store'
import ProvinceMessages from './localization'

export default {
  router,
  useProvinceStore,
  localization: ProvinceMessages,
}
